import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReportService } from 'src/app/shared/services/report.service';
import { ReportsDTO } from '../admin.dto';
import { Browser } from '@capacitor/browser';
import { AlertController } from '@ionic/angular';
@Component({
  selector: 'app-reports',
  templateUrl: './reports.page.html',
  styleUrls: ['./reports.page.scss'],
})
export class ReportsPage implements OnInit {
  reportsSub: Subscription;
  isLoading = true;
  filter = 'All';
  reports: ReportsDTO[];
  report: ReportsDTO;
  isModalOpen = false;
  constructor(private reportsService: ReportService, private alertCtrl: AlertController) { }
  ngOnInit() {
    this.reportsSub = this.reportsService.getReports().subscribe((reports) => {
      this.reports = reports;
      this.isLoading = false;
    });
  }
  ngOnDestroy() {
    if (this.reportsSub) {
      this.reportsSub.unsubscribe();
    }
  }
  handleRefresh(event: any) {
    this.reportsSub = this.reportsService.getReports().subscribe((reports) => {
      this.reports = reports
      event.target.complete();
      this.isLoading = false;
    });
  }
  ViewReport(report: ReportsDTO) {
    this.report = report;
    this.isModalOpen = true;
  }
  cancel() {
    this.isModalOpen = false;
  }
  async gotToLink() {
    const url = this.report.link;
    await Browser.open({ url });
  }

  markHandled() {
    this.alertCtrl
      .create({
        header: 'Update Report?',
        message: 'Are you sure you want to update this report?',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
              this.alertCtrl.dismiss();
            },
          },
          {
            text: 'Update',
            //  cssClass: 'confirm-delete',
            handler: () => {
              this.reportsService.markAsHandled(this.report.id).subscribe(res => {
                if (res) {
                  const index = this.reports.findIndex((b) => b.id === this.report.id);
                  this.reports[index].isHandled = true;
                  this.reports[index].handledDate = new Date();
                  this.cancel();
                }
              });
              this.alertCtrl.dismiss();
            },
          },
        ],
      })
      .then((alertEl) => alertEl.present());


  }


  deleteReport() {
    this.alertCtrl
      .create({
        header: 'Delete Report?',
        message: 'Are you sure you want to delete this report?',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
              this.alertCtrl.dismiss();
            },
          },
          {
            text: 'Delete',
            cssClass: 'confirm-delete',
            handler: () => {
              this.reportsService.deleteReport(this.report.id).subscribe(res => {
                if (res) {
                  const index = this.reports.findIndex((b) => b.id === this.report.id);
                  this.reports.splice(index, 1);
                  this.cancel();
                }
              });
              this.alertCtrl.dismiss();
            },
          },
        ],
      })
      .then((alertEl) => alertEl.present());
  }

  getType(type: string) {
    switch (type) {
      case 'user':
        return 'User';
      case 'post':
        return 'Doggogram Post';
      case 'postComment':
        return 'Comment on a Doggogram Post';
      case 'case':
        return 'Rescue Center Case';
      case 'caseComment':
        return 'Comment on a Rescue Center Case';
      default:
        return type;
    }
  }

  getReason(reason: string) {
    switch (reason) {
      case 'spam':
        return 'Spam / Irrelevant'
      case 'inappropriate':
        return 'Inappropriate / Offensive'
      case 'hate':
        return 'Hate Speech / Discrimination'
      case 'harassment':
        return 'Harassment / Bullying'
      case 'misinformation':
        return 'Misinformation / False Info'
      case 'animal_abuse':
        return 'Animal Abuse / Harmful Content'
      case 'illegal':
        return 'Illegal Activity'
      case 'scam':
        return 'Scam / Fraud'
      case 'other':
        return reason
      default:
        return reason
    }

  }
}